import {Api} from '../../../Api.js'

const RESOURCE = 'acl-model'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource)
    },
    get(model) {
        return Api().get(this.resource + '/' + model)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    delete(model) {
        return Api().delete(this.resource + '/' + model)
    },
    getPermissionsByModel(modelSelected) {
        return Api().get(this.resource + '/permissions/' + modelSelected)
    },
    getPermissionsByEntityModel(modelSelected) {
        return Api().get(this.resource + '/permissions/entity/' + modelSelected)
    },
    getAllPermissions() {
        return Api().get(this.resource + '/permissions')
    },
}


// WEBPACK FOOTER //
// ./src/modules/config/authorizations/AclModelService.js